import { Component, OnInit ,ViewChild, AfterViewInit} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;

@Component({
  selector: 'app-a2-general-list',
  templateUrl: './a2-general-list.component.html',
  styleUrls: ['./a2-general-list.component.scss']
})
export class A2GeneralListComponent extends GridBaseCase implements AfterViewInit{
  dataArrayList: Array<any> = [];
  storeArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  pageName:string = null;
  searchValue:string = null;//查询内容
  storeId:string = null;//门店id
  roles:string = null;//角色
  selectText:string = null;//选中的门店名字
  initLoadData:boolean = true;//第一次加载数据
  searchPlaceholder:string = null;//搜索框占位符
  isShowSelect:boolean = false;//是否显示下拉框
  isShowSearchInput:boolean = false;//是否显示搜索框
  writeOff:any=60;//会员在60个自然日内产生购买才能核销
  isCancelReceive:boolean = false;//是否取消领店
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super();
    let that = this;
    that.writeOff = app.writeOff || 60;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    this.com.GetAccount.Roles.forEach(role=>{
      // if(role.Code!="1003" && role.Code!="1004"){
        if(role.Code=="1003"){
       const store:any=document.getElementsByName("add-store");
       if(store.length>0){
        store.forEach(d=>{
          d.style.display="none";
        })
       }
      }
      // if(role.Code != "1003"){
        if(role.Code == "1003"){
        const store:any=document.getElementsByName("bind-store");
        if(store.length>0){
          store.forEach(d=>{
            d.style.display="none";
          })
        }
      }
      that.roles = role.Code;

    });


    if(this.pageName == "MyStore"){
      // this.isCancelReceive = true;
      this.baseService.FixedSubmitBtn.configName = "GeneralList";
      this.baseService.FixedSubmitBtn.isShow = true;
      // this.baseService.FixedSubmitBtn.text = "全部提交";
      this.baseService.FixedSubmitBtn.type = 3;
    }
    
    
  }
  ngAfterViewInit(){
    let that = this;
    let searchArr = that.com.GetStorageKey("searchArray") || [];
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput;
          // that.storeId = item.selectItem || null;
          // that.selectText = item["selectText"] || "";
        }
      })
    }
    switch(that.pageName){
      // case 'ProductInventoryList':
      //     if(that.roles != '1002'){
      //       that.isShowSelect = true;
      //     }
      //     that.LoadStoreData();
      //     break;
      // case 'MyStore':
      //     that.LoadDataInfo(1);
      //     break;
      default:
          that.LoadDataInfo(1);
    };
    let selectItem = that.element.selectItemList.selectItem;
    if(selectItem.length > 0){
      selectItem.forEach(item=>{
        if(item.elementType && item.elementType=="Search") {
          that.isShowSearchInput = true;
         that.searchPlaceholder = item.text;
        }
      })
    }

  }

  /**
   * 取消领取门店列表-选中方法
   * @param item 
   */
  checkStore(item){
    let that = this;
    item["isCheck"] = !item["isCheck"];
    if(!item["isCheck"]){
      that.baseService.FixedSubmitBtn["isCheckAll"] = false;
    }else{
      let _checkAll = true;
      that.dataArrayList.forEach(item=>{
        if(!item["isCheck"]){
          _checkAll = false;
        }
      })
      if(_checkAll){
        that.baseService.FixedSubmitBtn["isCheckAll"] = true;
      }
    }
  }

  /**
   * 取消领店
   * @param n 
   */
  EventSubmit(n){
    const that = this;
    if(n == 1){
      let _arr = [];
      that.dataArrayList.forEach(item=>{
        if(item["isCheck"]){
          _arr.push(item["id"]["value"]);
        }
      })
      if(_arr.length > 0){
        that.msg.Confirm("确认取消领店？").then(data=>{
          if(data){
            that.cancelReceiveStore(_arr);
          }
        })
      }else{
        that.msg.Alert("请选择要取消领取的门店!");
      }
      
    }else if(n == 2){
      if(that.baseService.FixedSubmitBtn["isCheckAll"]){
        that.dataArrayList.forEach(item=>{
          item["isCheck"] = true;
        })
      }else{
        that.dataArrayList.forEach(item=>{
          item["isCheck"] = false;
        })
      }
    }else if(n == 3){
      that.baseService.FixedSubmitBtn['isCancelReceive'] = true;
    }else if(n == 4){
      that.baseService.FixedSubmitBtn['isCancelReceive'] = false;
    }
  }
  /**
   * 取消领取门店
   * @param arr 
   */
  cancelReceiveStore(arr){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "RelievePeopleAndStores";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify({storeIds:arr})
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.msg.Alert("取消领店成功！");
        that.LoadData(1);
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  EventLink(event,item){
    // console.log(item);
    this.com.setHistoryUrl();
    // this.router.navigate([event.url+"getedite/"+item.id.value+"&"+this.com.getNowDatetime]);
    this.com.Go(event.url+"getedite/"+item.id.value+"&"+this.com.getNowDatetime);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadDataInfo(that.PageNumber);
    }
  }
  LoadDataInfo(PageNumber){
    let that = this;
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = {};
    if(PageName=="VipScore"){//会员积分
      body.RequestBody = {"FK_SystemUser_ID":that.com.GetAccount.Id};
    }else if(PageName=="GiftInventorySignList"){
      if(id){
        body.RequestBody = {"a_FK_TBGiftOrder_ID":id.split("&")[0]};
      }
      
      // body.RequestBody = JSON.stringify({"a_FK_TBGiftOrder_ID":id,"a_IsSigned":false});
    }else if(PageName=="GiftInventoryList"){
      body.RequestBody = {"a_IsSigned":true};
    }else if(PageName == "PGManageList" || PageName == "PGScheduleList" || PageName == "PGClockInList"){
      body.RequestBody = {"r_Code":"1002"};
      if(that.searchValue){
        body.RequestBody["uar_name"] = that.searchValue.trim();
      }
    }else if(PageName=="mykpiList"||PageName=="mykpiList1"||PageName=="mykpiList2"){//kpi历史数据
      if(id){
        body.RequestBody = {"a_Code":id.split("&")[0],"a_ID":that.com.GetAccount.Id};
      }
    }else if(PageName=="StoreFeedbackList"){//门店问题反馈
      let objStore:any={};
          objStore["a_FK_SystemUser_ID"]=that.com.GetAccount.Id;
      if(that.com.GetStorageKey("tbstore")){
        objStore["a_FK_Store_ID"]=that.com.GetStorageKey("tbstore")["ID"];
      }
      body.RequestBody = objStore;
    }else if(PageName == "ProductInventoryList"){
      body.RequestBody = {"a_FK_TBStore_ID":id.split("&")[0]};
    }
    else if(PageName == "FeedbackonSubsidyDisbursement"){//补贴发放反馈
      let temp = {};
      if(that.com.GetStorageKey("tbstore")){
        temp["a_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore")["ID"];
      }
      body.RequestBody = temp;
    }
    else if(PageName == "DayOrderList"){//日开单明细
      let temp = {};
      temp["orderid"]=id.split("&")[0];
      body.RequestBody = temp;
    }
    else if(PageName == "ActivityReceiveList"){
      let temp = {};
      temp["a_FK_TBActivity_ID"]=id.split("&")[0];
      body.RequestBody = temp;
    }
    if(that.searchValue && (that.pageName != 'PGManageList' && that.pageName != 'PGScheduleList' && that.pageName != 'PGClockInList')){
      let selectItem = that.element.selectItemList.selectItem;
      if(selectItem.length > 0){
        selectItem.forEach(item=>{
          if(item.elementType && item.elementType=="Search") {
            body.RequestBody[item.field] = that.com.LikeSearch(that.searchValue.trim());
          }
        })
      }
    }
    const _searchObj = {
      pageName:PageName,
      searchInput:that.searchValue,
      // selectItem:that.storeId,
      // selectText:that.selectText
    };
    that.com.SaveSearchInfo(_searchObj);
    
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      console.log(10086);
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              if(PageName=="DayOrderList" || PageName=="ProductInventoryList" ){//日开单查询明细
                // debugger;
                if(element.bindingField=="shortName" && item[element.field]){
                 objfield["productName"] = { "value": item[element.field], "text": element.text };
                }else if(element.bindingField=="productName" && (objfield["productName"]?objfield["productName"].value:true)){
                  objfield["productName"] = { "value": item[element.field], "text": element.text };
                }
                let _tyle=element.bindingField;
                if(_tyle!="shortName" && _tyle!="productName"){
                  objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
                }
             }else{
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
             }
             
            }
            // if (element.bindingField) {
            //   if(PageName=="ProductInventoryList" ){//日存货
            //     // debugger;
            //     if(element.bindingField=="shortName" && item[element.field]){
            //      objfield["productName"] = { "value": item[element.field], "text": element.text };
            //     }else if(element.bindingField=="productName" && (objfield["productName"]?objfield["productName"].value:true)){
            //       objfield["productName"] = { "value": item[element.field], "text": element.text };
            //     }
            //     let _tyle=element.bindingField;
            //     if(_tyle!="shortName" && _tyle!="productName"){
            //       objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            //     }
            //  }else{
            //   objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            //  }
             
            // }
            if(element.formatter && element.formatter == "Date"){
              if(objfield[element.bindingField].value){
                objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
              }
            }
            if(element.bindingField == 'deadline' && objfield[element.bindingField] && objfield[element.bindingField].value){
              let _time = objfield[element.bindingField].value.replace(/-/g,"/");
              
              let _date = new Date(_time).getTime() + parseInt(that.writeOff) * 24 * 60 * 60 * 1000;
              let _newDate = new Date(_date);
              objfield[element.bindingField].value = _newDate;
            }
            if(objfield["phone"] && objfield["phone"].value){
              objfield["phone"].value=that.com.PhoneNum(objfield["phone"].value);
            }
            if(objfield["name"] && objfield["name"].value){
              objfield["name"].value=that.com.FormatName(objfield["name"].value);
            }
          });
          that.dataArrayList.push(objfield);
          // that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          
        });
        if(PageName=="mykpiList"){
          that.dataArrayList.forEach(item=>{
            let num1:number = item.Num.value;
            let num2:number = item.nVolumeum.value;
            let num3:any = 0;
            if(num1==0){
              num3=0;
            }else{
              let num4:number = num1/num2;
              num3=num4.toFixed(2);
            }
            item.nVolumeum.value = num3+"%";
          });
        }else if(PageName == "MyStore"){
          let _checkAll = true;
          that.dataArrayList.forEach(item=>{
            if(!item["isCheck"]){
              _checkAll = false;
            }
          })
          if(_checkAll){
            that.baseService.FixedSubmitBtn["isCheckAll"] = true;
          }else{
            that.baseService.FixedSubmitBtn["isCheckAll"] = false;
          }
        }

         console.log(that.dataArrayList,"数据1");
        //   console.log(that.element);
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
 /**
  * 跳转详细页面
  * @param element 
  * @param item 
  */
 EventClick(element,item){
   const that=this;
   if(that.baseService.FixedSubmitBtn['isCancelReceive']){
    that.checkStore(item);
    return;
   }
   if(element.url){
    that.com.setHistoryUrl();
    if(this.pageName == 'GiftInventorySignList' && item["isSign"] &&  item["isSign"].value){
      // this.router.navigate(["/tabs/contact/GiftInventorySignForm/view/"+item.id.value + "&" + this.com.getNowDatetime]);
      that.com.Go("/tabs/contact/GiftInventorySignForm/view/"+item.id.value + "&" + this.com.getNowDatetime);
      console.log("11111111111111")
    }else if(this.pageName == 'ActivityReceiveList'){
      if(item.activityReceiveCode && (item.activityReceiveCode.value=="GC001" || item.activityReceiveCode.value=="GC005")){
        // that.router.navigateByUrl("/tabs/contact/ActivityReceiveDetail1/view/"+item.id.value+"&"+that.com.getNowDatetime);
        that.com.Go("/tabs/contact/ActivityReceiveDetail1/view/"+item.id.value+"&"+that.com.getNowDatetime);
        console.log("222222222")
      }else{
        // that.router.navigateByUrl("/tabs/contact/ActivityReceiveDetail2/view/"+item.id.value+"&"+that.com.getNowDatetime);
        that.com.Go("/tabs/contact/ActivityReceiveDetail2/view/"+item.id.value+"&"+that.com.getNowDatetime)
        console.log("333333333")
      }
      /* */
    }else if(this.pageName=="PGManageList"){
      that.com.Go(element.url+item.id.value  +"&"+ item.tbcode.value+ "&" + that.com.getNowDatetime);
    }
    else{
      
      // that.router.navigate([element.url+item.id.value + "&" + that.com.getNowDatetime]);
      that.com.Go(element.url+item.id.value + "&" + that.com.getNowDatetime);
     
    }
   }
 }

   /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      this.LoadDataInfo(1);
    }
  }
  changeSelect(e){
    let that = this;
    that.storeId = e.target.value || "";
    if(that.storeId){
      that.storeArrayList.forEach((item)=>{
        if(item["a_ID"] == that.storeId){
          that.selectText = item["a_Name"];
        }
      })
    }
    this.LoadDataInfo(1);

  }

  LoadStoreData(){
    let that = this;
    // console.log("1008611");
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
   
    body.ConfigName = "TBStoreXML";
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 100;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.storeArrayList = data.Status.Datas;
        if(!that.storeId && that.storeArrayList.length > 0){
          that.storeId = that.storeArrayList[0]["a_ID"];
          that.selectText = that.storeArrayList[0]["a_Name"];
        }
        that.LoadDataInfo(1);
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  LoadData(PageNumber){
    if(!this.initLoadData){
      this.LoadDataInfo(PageNumber);
    }else{
      this.initLoadData = false;
    }
  }
}
